import { render, staticRenderFns } from "./GoodsStationModal.vue?vue&type=template&id=bcda01ae"
import script from "./GoodsStationModal.vue?vue&type=script&lang=js"
export * from "./GoodsStationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcda01ae')) {
      api.createRecord('bcda01ae', component.options)
    } else {
      api.reload('bcda01ae', component.options)
    }
    module.hot.accept("./GoodsStationModal.vue?vue&type=template&id=bcda01ae", function () {
      api.rerender('bcda01ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/print/GoodsStationModal.vue"
export default component.exports